export const getDeleteUserRoleQuery = (params: { brokerageId?: string }) => {
  const { brokerageId } = params;
  const query = new URLSearchParams();
  if (brokerageId) {
    query.append('brokerageId', brokerageId);
  }
  return query.toString();
};
